import BaseResponse from "@/model/responses/BaseResponse";

class CustomerResponse extends BaseResponse {
  static readBy = {
    data: {
      customerId: null,
      customerName: null,
      customerFirstName: null,
      customerLastName: null,
      customerGPS: null,
      customerEnrollmentDate: null,
      customerCountry: null,
      customerState: null,
      customerCity: null,
      customerStreet: null,
      customerEmail: null,
      customerPhoneNumber: null,
      customerCountryCode: null,
      customerPassword: null,
      customerDisplayPicture: null,
      customerCoverPhoto: null,
      customerGender: null,
      customerPwbId: null,
      customerPwbAccount: null,
      customerOtp: null,
      customerOtpUpdatedAt: null,
      customerLastLoginAt: null,
      customerDOB: null,
      customerAbout: null,
      customerInterest: null,
      customerTimezone: null,
      customerWalletId: null,
      customerPayOutAccountId: null,
      customerNotificationPreference: null,
      customerCreatedAt: null,
      customerUpdatedAt: null,
      customerLoginAttempt: null,
      customerStatus: null
    }
  };
}

export default CustomerResponse;
